<h1 mat-dialog-title style="justify-content: space-between;">
    Select Components Log Level
    <mat-icon (click)="onClose()" class="tis-curser-pointer">clear</mat-icon>
</h1>

<mat-dialog-content appScrolling class="w-100 p-0 m-0" style="max-height: 60vh !important;">
    <div class="search-container">
        <mat-icon class="icon">search</mat-icon>
        <input type="text" placeholder="Search" class="search-bar" [formControl]="searchControl" />
    </div>
    <div class="example-list">
        @if(!searchControl.value) {
        <div class="example-box">
            <div class="w-full grid grid-cols-12 gap-3">
                <div class="flex flex-row items-center col-span-12 md:col-span-12 lg:col-span-6">
                    <span>All</span>
                </div>
                <div class="flex justify-end col-span-12 md:col-span-12 lg:col-span-6">
                    <mat-radio-group (change)="onLogLevelAllChange($event.value)" aria-label="Select an option"
                        class="tis-mat-radio-group-accent w-full flex gap-3 justify-between">
                        <mat-radio-button [value]="LogLevel.DEBUG"> {{ LogLevel.DEBUG }} </mat-radio-button>
                        <mat-radio-button [value]="LogLevel.WARN"> {{ LogLevel.WARN }} </mat-radio-button>
                        <mat-radio-button [value]="LogLevel.ERROR"> {{ LogLevel.ERROR }} </mat-radio-button>
                        <mat-radio-button [value]="LogLevel.NONE"> {{ LogLevel.NONE }} </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
        }
        <div class="example-box" *ngFor="let item of options | async, let ndx = index" cdkDrag>
            <div class="w-full grid grid-cols-12 gap-3">
                <div class="flex flex-row items-center col-span-12 md:col-span-12 lg:col-span-6">
                    <span>{{item.componentName }}</span>
                </div>
                <div class="flex justify-end col-span-12 md:col-span-12 lg:col-span-6">
                    <mat-radio-group [value]="item.logLevel" (change)="onLogLevelChange(item, $event.value)"
                        aria-label="Select an option"
                        class="tis-mat-radio-group-accent w-full flex gap-3 justify-between">
                        <mat-radio-button [value]="LogLevel.DEBUG" [checked]="item.logLevel == LogLevel.DEBUG "> {{
                            LogLevel.DEBUG }} </mat-radio-button>
                        <mat-radio-button [value]="LogLevel.WARN" [checked]="item.logLevel == LogLevel.WARN "> {{
                            LogLevel.WARN }} </mat-radio-button>
                        <mat-radio-button [value]="LogLevel.ERROR" [checked]="item.logLevel == LogLevel.ERROR "> {{
                            LogLevel.ERROR }} </mat-radio-button>
                        <mat-radio-button [value]="LogLevel.NONE" [checked]="item.logLevel == LogLevel.NONE "> {{
                            LogLevel.NONE }} </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<div mat-dialog-actions>
    <button mat-button type="button" class="t-upper tis-btn-primary" mat-dialog-close [disabled]="loading">OK</button>
</div>